import api from 'Application/api/api';

const getCurrentUser = signal =>
	api.get('/users/current', {
		signal,
	});

export default getCurrentUser;
